var $houses = [];

function initWoningen() {
    var typingTimer;
    var doneTypingInterval = 1500;

    $('.naw-form').each(function (index) {

        const houseNumberElement = $('#naw-houseNumber-' + index);
        const postCodeElement = $('#naw-postCode-' + index);

        //on keyup, start the countdown
        houseNumberElement.on('keyup', timer);
        postCodeElement.on('keyup', timer);
        houseNumberElement.on('focusout', timer);
        postCodeElement.on('focusout', timer);

        //on keydown, clear the countdown
        houseNumberElement.on('keydown', function () {
            clearTimeout(typingTimer);
        });

        postCodeElement.on('keydown', function () {
            clearTimeout(typingTimer);
        });
    });


    function timer() {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(addressElementChanged, doneTypingInterval);
    }

    function addressElementChanged() {
        $('.naw-form').each(function (index) {
            const postCodeVal = $('#naw-postCode-' + index).val();
            const houseNumberVal = $('#naw-houseNumber-' + index).val();
            const addressField = $('#naw-address-' + index);

            if (postCodeVal && houseNumberVal) {

                $('#naw-city-' + index).attr('placeholder', 'Adresgegevens worden opgehaald...');
                $('#naw-address-' + index).attr('placeholder', 'Adresgegevens worden opgehaald...');

                $('#naw-city-' + index).removeAttr('value');
                $('#naw-address-' + index).removeAttr('value');

                console.log('Trying AJAX for '+ postCodeVal + ' ' + houseNumberVal);

                $.ajax({
                    url: '',
                    dataType: "json",
                    type: 'POST',
                    data: {
                        'action': 'AddressFinder',
                        'postcode': postCodeVal,
                        'houseNumber': houseNumberVal,
                    },
                    success: function (result) {
                        const parsedResult = JSON.parse(result);

                        addressField.attr('value', parsedResult.street);
                        $('#naw-city-' + index).attr('value', parsedResult.city);


                        $('#naw-latitude-' + index).attr('value', parsedResult.location.coordinates[1]);
                        $('#naw-longitude-' + index).attr('value', parsedResult.location.coordinates[0]);


                        // Remove error class if present
                        $('#naw-postCode-' + index).removeClass('naw-error');
                        $('#naw-houseNumber-' + index).removeClass('naw-error');

                        $('#naw-city-' + index).attr('placeholder', 'Wordt automatisch aangevuld');
                        $('#naw-address-' + index).attr('placeholder', 'Wordt automatisch aangevuld');
                    },
                    error: function (e) {
                        $('#naw-postCode-' + index).addClass('naw-error');
                        $('#naw-houseNumber-' + index).addClass('naw-error');

                        $('#naw-city-' + index).attr('placeholder', 'Wordt automatisch aangevuld');
                        $('#naw-address-' + index).attr('placeholder', 'Wordt automatisch aangevuld');
                    }
                });
            }
        })
    }

    $houses = $('.house-block');
    $('.prijs_min, .prijs_max, .house-type-checkbox, .room-checkbox, .surface-radio').change(function () {
        updateHouses(false);
    });
    $('.surface-ground-radio, .sort, .parking-radio, .available-radio, .outside-checkbox').change(function () {
        updateHouses(false);
    });

    $('.current-filters > div').hide();

    $('.reset-btn').click(function () {
        $('.prijs_min option:first').prop('selected', true);
        $('.prijs_max option:first').prop('selected', true);
        $('.house-type-checkbox').prop('checked', false);
        $('.room-checkbox').prop('checked', false);
        $('.surface-radio').prop('checked', false);
        $('.surface-ground-radio').prop('checked', false);
        $('.parking-radio').prop('checked', false);
        $('.available-radio').prop('checked', false);
        $('.outside-checkbox').prop('checked', false);

        updateHouses(false);
    });

    if ($('.houses-section').length > 0) {
        updateHouses(true);
    }
}

$(function() {
    initWoningen();
});

function updateHouses(initial) {
    var data = getData();
    data.action = 'Filter';

    if(initial == undefined) {
        initial = false;
    }

    $.fancybox.showLoading();

    $.post(window.location.href, data, function(result) {
        $('.houses-result').html(result);
        $('.houses-overview-left').height('auto');
        $('.houses-overview-right').height('auto');
        $('.match-height').matchHeight();
        var hasResult = false;

        data.action = 'Counter';

        data.type = 'houseTypes';
        $.post(window.location.href, data, function(result) {
            result = groupBy(JSON.parse(result), 'project_woning_type_id');
            $('.count-house-type').text(0);
            if(initial) {
                $('.count-house-type').closest('li').hide();
                hasResult = false;
            }
            for(var id in result) {
                $('.count-house-type-' + id).text(result[id] != undefined ? result[id].length : 0);
                if(initial && result[id] != undefined && result[id].length > 0) {
                    $('.count-house-type-' + id).closest('li').show();
                    hasResult = true;
                }
            }
            if(initial && result[id] != undefined && result[id].length == 0) $('.count-house-type-' + id).closest('li').hide();
        });

        data.type = 'rooms';
        $.post(window.location.href, data, function(result) {
            result = groupBy(JSON.parse(result), 'kamers');
            $('.count-room').text(0);
            if(initial) {
                $('.count-room').closest('li').hide();
                hasResult = false;
            }
            for(var id in result) {
                $('.count-room-' + id).text(result[id].length);
                if(initial && result[id].length > 0) {
                    $('.count-room-' + id).closest('li').show();
                    hasResult = true;
                }
            }
            if(initial && !hasResult) $('.count-room').closest('.house-filter-block').hide();
        });

        data.type = 'surface';
        $.post(window.location.href, data, function(result) {
            result = JSON.parse(result);
            $('.count-space').text(0);
            for(var id in result) {
                result[id].woonoppervlakte = NearestMultiple(result[id].woonoppervlakte, 25);
            }

            result = groupBy(result, 'woonoppervlakte');
            if(initial) {
                $('.count-space').closest('li').hide();
                hasResult = false;
            }
            for(var id in result) {
                $('.count-space-' + id).text(result[id].length);
                if(initial && result[id] != undefined && result[id].length > 0) {
                    $('.count-space-' + id).closest('li').show();
                    hasResult = true;
                }
            }
            if(initial && !hasResult) $('.count-space').closest('.house-filter-block').hide();
        });

        data.type = 'groundSurface';
        $.post(window.location.href, data, function(result) {
            result = JSON.parse(result);
            $('.count-ground-space').text(0);
            for(var id in result) {
                result[id].grondoppervlakte = NearestMultiple(result[id].grondoppervlakte, 50);
            }

            result = groupBy(result, 'grondoppervlakte');

            if(initial) {
                $('.count-ground-space').closest('li').hide();
                hasResult = false;
            }

            for(var id in result) {
                $('.count-ground-space-' + id).text(result[id].length);
                if(initial && result[id] != undefined && result[id].length > 0) {
                    $('.count-ground-space-' + id).closest('li').show();
                    hasResult = true;
                }
            }
            if(initial && !hasResult) $('.count-ground-space').closest('.house-filter-block').hide();
        });

        data.type = 'outside';
        $.post(window.location.href, data, function(result) {
            result = JSON.parse(result);
            $('.count-outside').text(0);
            var newResult = [];
            for(var id in result) {
                if(result[id].buitenruimte.length > 0) {
                    var object = JSON.parse(result[id].buitenruimte);
                    for(var id in object) {
                        newResult.push({'property': object[id]});
                    }
                }
            }
            result = groupBy(newResult, 'property');

            if(initial) {
                $('.count-outside').closest('li').hide();
                hasResult = false;
            }

            for(var id in result) {
                $('.count-outside-' + id).text(result[id].length);
                if(initial && result[id] != undefined && result[id].length > 0) {
                    $('.count-outside-' + id).closest('li').show();
                    hasResult = true;
                }
            }
            if(initial && !hasResult) $('.count-outside').closest('.house-filter-block').hide();
        });

        data.type = 'status';
        $.post(window.location.href, data, function(result) {
            result = groupBy(JSON.parse(result), 'status');
            // result['FOR_SALE'] = result['FOR_SALE'] != undefined ? result['FOR_SALE'].concat(result['OPTION']) : result['OPTION'];
            $('.count-available').text(0);
            for(var id in result) {
                $('.count-available-' + id).text(result[id] != undefined ? result[id].length : 0);
                if(initial && result[id] != undefined && result[id].length > 0) {
                    $('.count-available-' + id).closest('li').show();
                    hasResult = true;
                }
            }
            if(initial && !hasResult) $('.count-available').closest('.house-filter-block').hide();
        });

        data.type = 'parking';
        $.post(window.location.href, data, function(result) {
            result = JSON.parse(result);
            $('.count-parking').text(0);
            var newResult = [];
            for(var id in result) {
                if(result[id].parkeren.length > 0) {
                    var object = JSON.parse(result[id].parkeren);
                    for(var id in object) {
                        newResult.push({'property': object[id]});
                    }
                }
            }
            result = groupBy(newResult, 'property');


            if(initial) {
                $('.count-parking').closest('li').hide();
                hasResult = false;
            }

            for(var id in result) {
                $('.count-parking-' + id).text(result[id].length);
                if(initial && result[id].length > 0) {
                    $('.count-parking-' + id).closest('li').show();
                    hasResult = true;
                }
            }

            if(initial && !hasResult) $('.count-parking').closest('.house-filter-block').hide();
        });

        if(initial && params.type != undefined && params.type > 0) {
            $('.house-type-checkbox[value='+params.type+']').prop('checked', true);
            $('.available-radio[value='+params.available+']').prop('checked', true);
            updateHouses();
        }else {
            $.fancybox.hideLoading();
        }

        $('.count-total-houses').text($('.house-block').length);
    });
}

function NearestMultiple(i, j) {
    return Math.floor(i/ j) * j;
}

function updateCurrentFilters() {
    var data = getData();
    $('.current-filters > div').hide();

    var html = '';
    if(data.houseTypes.length > 0) {
        for (var i = 0; i < data.houseTypes.length; i++) {
            var text = $('.house-type-checkbox[value=' + data.houseTypes[i] + ']').next().text();
            var value = data.houseTypes[i];
            html += '<li>' + text + ' <a data-value="' + value + '" onclick="unsetFilter(\'type\', $(this).data(\'value\'))">x</a></li>';
        }
        $('.current-filters .current-filter-type').show();
        $('.current-filters .current-filter-type ul').html(html);
    }else{
        $('.current-filters .current-filter-type').hide();
    }

    var html = '';
    if(data.rooms.length > 0) {
        for (var i = 0; i < data.rooms.length; i++) {
            var text = $('.room-checkbox[value=' + data.rooms[i] + ']').next().text();
            var value = data.rooms[i];
            html += '<li>' + text + ' kamers  <a data-value="' + value + '" onclick="unsetFilter(\'room\', $(this).data(\'value\'))">x</a></li>';
        }
        $('.current-filters .current-filter-rooms').show();
        $('.current-filters .current-filter-rooms ul').html(html);
    }else{
        $('.current-filters .current-filter-rooms').hide();
    }

    var html = '';
    if(data.surface != undefined) {
        var value = parseInt(data.surface);
        var text = $('.surface-radio[value=' + value + ']').next().text();
        html += '<li>' + text + ' <a data-value="' + value + '" onclick="unsetFilter(\'surface\', $(this).data(\'value\'))">x</a></li>';
        $('.current-filters .current-filter-surface').show();
        $('.current-filters .current-filter-surface ul').html(html);
    }else{
        $('.current-filters .current-filter-surface').hide();
    }

    var html = '';
    if(data.groundSurface != undefined) {
        var value = parseInt(data.groundSurface);
        var text = $('.surface-ground-radio[value=' + value + ']').next().text();
        html += '<li>' + text + ' <a data-value="' + value + '" onclick="unsetFilter(\'ground-surface\', $(this).data(\'value\'))">x</a></li>';
        $('.current-filters .current-filter-ground-surface').show();
        $('.current-filters .current-filter-ground-surface ul').html(html);
    }else{
        $('.current-filters .current-filter-ground-surface').hide();
    }

    var html = '';
    if(data.status.length > 0) {
        for (var i = 0; i < data.status.length; i++) {
            var text = $('.available-radio[value=' + data.status[i] + ']').next().text();
            var value = data.status[i];
            html += '<li>' + text + ' <a data-value="' + value + '" onclick="unsetFilter(\'status\', $(this).data(\'value\'))">x</a></li>';
        }
        $('.current-filters .current-filter-status').show();
        $('.current-filters .current-filter-status ul').html(html);
    }else{
        $('.current-filters .current-filter-status').hide();
    }

    var html = '';
    if(data.parking.length > 0) {
        for (var i = 0; i < data.parking.length; i++) {
            var text = $('.parking-radio[value=' + data.parking[i] + ']').next().text();
            var value = data.parking[i];
            html += '<li>' + text + ' <a data-value="' + value + '" onclick="unsetFilter(\'parking\', $(this).data(\'value\'))">x</a></li>';
        }
        $('.current-filters .current-filter-parking').show();
        $('.current-filters .current-filter-parking ul').html(html);
    }else{
        $('.current-filters .current-filter-parking').hide();
    }

    var html = '';
    if(data.outside.length > 0) {
        for (var i = 0; i < data.outside.length; i++) {
            var text = $('.outside-checkbox[value=' + data.outside[i] + ']').next().text();
            var value = data.outside[i];
            html += '<li>' + text + ' <a data-value="' + value + '" onclick="unsetFilter(\'outside\', $(this).data(\'value\'))">x</a></li>';
        }
        $('.current-filters .current-filter-outside').show();
        $('.current-filters .current-filter-outside ul').html(html);
    }else{
        $('.current-filters .current-filter-outside').hide();
    }
}

function getData() {
    var minPrice = $('.prijs_min').val(),
        maxPrice = $('.prijs_max').val();

    var houseTypes = [];
    $('.house-type-checkbox').each(function() {
        if($(this).is(':checked')) houseTypes.push($(this).val());
    });

    var rooms = [];
    $('.room-checkbox').each(function() {
        if($(this).is(':checked')) rooms.push($(this).val());
    });

    var surface = $('.surface-radio:checked').val();
    var groundSurface = $('.surface-ground-radio:checked').val();

    var status = [];
    $('.available-radio').each(function() {
        if($(this).is(':checked')) status.push($(this).val());
    });

    var parking = [];
    $('.parking-radio').each(function() {
        if($(this).is(':checked')) parking.push($(this).val());
    });

    var outside = [];
    $('.outside-checkbox').each(function() {
        if($(this).is(':checked')) outside.push($(this).val());
    });

    var sort = $('.sort option:selected').val();

    return {
        'minPrice': minPrice,
        'maxPrice': maxPrice,
        'houseTypes': houseTypes,
        'rooms': rooms,
        'surface': surface,
        'groundSurface': groundSurface,
        'status': status,
        'parking': parking,
        'outside': outside,
        'sort': sort
    };
}
